import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api } from '../lib/api.ts';

/** 개인정보 파일 대장에서 여러 파일 선택 (위탁·제공·국외이전·점검 근거) */
export function PiiFileSelect({ value, onChange }: { value: string[]; onChange: (ids: string[]) => void }) {
  const q = useQuery({ queryKey: ['pii-files-lite'], queryFn: () => api<Array<{ id: string; name: string; systemName: string }>>('/ledgers/pii-files/lite') });
  const list = q.data ?? [];
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 max-h-28 overflow-auto w-full">
      {list.map((f) => <label key={f.id} className="ft-check"><input type="checkbox" checked={value.includes(f.id)} onChange={(e) => onChange(e.target.checked ? [...value, f.id] : value.filter((x) => x !== f.id))} />{f.name}{f.systemName && <span className="text-slate-400"> · {f.systemName}</span>}</label>)}
      {!list.length && <span className="text-[12px] text-slate-400">등록된 개인정보 파일이 없습니다. <Link className="text-accent-strong hover:underline" to="/ledgers/pii-files/new">대장에 등록</Link></span>}
    </div>
  );
}
